import { __spreadArray, __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { Box, Typography } from '@mui/material';
import React__default from 'react';
import ZigCheckBox from '../../../../inputs/ZigCheckBox/index.js';

var CheckBoxFilter = function (_a) {
    var filter = _a.filter, onChange = _a.onChange;
    var label = filter.label, options = filter.options, value = filter.value, id = filter.id;
    var handleChange = function (o, checked) {
        var updatedValue = __spreadArray([], (value !== null && value !== void 0 ? value : options.map(function (o) { return o.value; })), true);
        if (checked) {
            if (!updatedValue.includes(o)) {
                updatedValue.push(o);
            }
            if (options.every(function (o) { return updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.includes(o.value); })) {
                updatedValue = null;
            }
        }
        else {
            updatedValue = updatedValue.filter(function (option) { return option !== o; });
        }
        onChange(__assign(__assign({}, filter), { value: updatedValue }));
    };
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column" },
        label && (React__default.createElement(Typography, { component: "div", pb: 1, id: "filter-checkbox-".concat(id, "__label") }, label)),
        options.map(function (option, i) { return (React__default.createElement(Box, { py: "6px", key: option.value },
            React__default.createElement(ZigCheckBox, { variant: "outlined", sx: { margin: "0 9px", padding: 0 }, id: "filter-checkbox-".concat(id, "__option-").concat(i), checked: !value || (value === null || value === void 0 ? void 0 : value.includes(option.value)), label: option.label, onChange: function (checked) { return handleChange(option.value, checked.target.checked); } }))); })));
};

export { CheckBoxFilter as default };
